/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "common": {
        "nested": {
          "audit": {
            "nested": {
              "AuditTrail": {
                "fields": {
                  "actorToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "actorUid": {
                    "type": "int32",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.common?.nested?.audit?.nested?.AuditTrail) {
  $root.addJSON(jsonData);
}

/**
 * Details on the actor and the reason for an API request
 *
 * SOURCE AuditTrail @ squareup/common/audit.proto at 8:1
 */
export const AuditTrail = $root.lookupType('squareup.common.audit.AuditTrail');
fixType(AuditTrail, {
  actorToken: {
    notEmpty: true
  },
  reason: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(AuditTrail);